import URLBuilder from "./URLBuilder";

export const PageURL = new URLBuilder();

export default PageURL;



// WEBPACK FOOTER //
// ./src/lib/routing/PageURL.js